/**
 * HomeFilterPanelContent — thin wrapper around canonical FeedFilterPanelContent.
 */
import * as React from 'react';
import { Newspaper, Pin, Users } from 'lucide-react';
import {
  FeedFilterPanelContent,
  type FeedSectionOption,
  type FeedTaxonomyOption,
} from '@bright-web-skeleton/ui';
import type { HomeSectionKey } from './HomeShortcutRail';

export type TaxonomyOption = FeedTaxonomyOption;

export interface HomeFilterPanelContentProps {
  searchQuery: string;
  onSearchQueryChange: (q: string) => void;
  activeSections: HomeSectionKey[];
  onToggleSection: (section: HomeSectionKey) => void;
  industryOptions?: TaxonomyOption[];
  activeIndustryIds?: string[];
  onToggleIndustry?: (id: string) => void;
  categoryOptions?: TaxonomyOption[];
  activeCategoryIds?: string[];
  onToggleCategory?: (id: string) => void;
  onApply: () => void;
  onClear: () => void;
  onClearAll: () => void;
  hasCommittedFilters?: boolean;
  draftMatchesCommitted?: boolean;
}

const SECTION_OPTIONS: FeedSectionOption<HomeSectionKey>[] = [
  { key: 'news', label: 'News', icon: Newspaper },
  { key: 'pinned', label: 'Pinned', icon: Pin },
  { key: 'following', label: 'Following', icon: Users },
];

export const HomeFilterPanelContent: React.FC<HomeFilterPanelContentProps> = (props) => (
  <FeedFilterPanelContent<HomeSectionKey>
    {...props}
    sectionOptions={SECTION_OPTIONS}
    sectionTitle="Feed Sections"
    searchPlaceholder="Search your feed..."
  />
);

export default HomeFilterPanelContent;